import { create } from 'zustand';
import {persist} from "zustand/middleware"

export const useMapStore = create(
  persist(
    (set) => ({
      center: { lat: 52.5175, lng: 13.4025 , elv: 40},
      zoom: 14,
      scalingFactor: null,
      planeDimensions: null,
      currentLocation:
        "Vera Britain Ufer, Karl-Liebknecht-Str. 1, 10178 Berlin",
      home: "Vera Britain Ufer, Karl-Liebknecht-Str. 1, 10178 Berlin",
      homeCoordinates :{lat: 52.5175, lng: 13.4025},
      elevationRangeMin: 40,

      // actions
      updateHome: (home) => set({ home }),
      updateElevationRangeMin: (elevationRangeMin) => set({ elevationRangeMin }),
      updateHomeCoordinates: (homeCoordinates) => set({ homeCoordinates }),
      updateLocation: (currentLocation) => set({ currentLocation }),
      updateMapView: (center, zoom) => set({ center, zoom }),
      updateScalingFactor: (scalingFactor) => set({ scalingFactor }),
      updatePlaneDimensions: (planeDimensions) => set({ planeDimensions }),
    }),
    {
      name: "map-store", //  key in localStorage
    }
  )
);


export const useMapRef = create(
  persist(
    (set) => ({
      mapref: null,
      updateMapref: (mapref) => set({ mapref }),
    }),
    {
      name: "map-ref-store",
    }
  )
);
export const useCRSStore = create(
  persist(
    (set) => ({
      epsgCRS: "EPSG25832", // Default CRS
      updateEPSGCRS: (epsgCRS) => set({ epsgCRS }),
    }),
    {
      name: "crs-store",
    }
  )
);